export const GLOBAL_DESTROY_SESSION = 'global/destroySession';
